import { render, staticRenderFns } from "./ModalEntarimarComponentDevolucion.vue?vue&type=template&id=265f510c&"
import script from "./ModalEntarimarComponentDevolucion.vue?vue&type=script&lang=js&"
export * from "./ModalEntarimarComponentDevolucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports